/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { AuthorInfo, Category, Container, Content, ContentWrpper, MetaInfo, MetaWrapper, SponsoredBy, Tag, Title } from './styles/cpds-subtitle-paragraph-style';
import { CpdsSubtitleParagraphProps } from './typings';
import { Cpds } from '@Cpds.Ui';
import { ThemeColorMode, themeStyleClass } from '../utils/cpds-utils';

const CpdsSubtitleParagraph: React.FC<CpdsSubtitleParagraphProps> = (props) => {
  const { domRef, exClasses, styleOverrides, paragraphData, themeTypography, contentAlignment, ...rest } = props;

  const className = themeStyleClass('cpds-subtitle-paragraph', themeTypography, exClasses);

  /* Important : By default html tag is <div></div> 
  but you can change that into suitable html element base on your requirements*/
  return (
    <Container className={className} ref={domRef} styleOverrides={styleOverrides} {...rest}>
      <ContentWrpper contentAlignment={contentAlignment}>
        <Title>{paragraphData?.title}</Title>
        <Content>
          {paragraphData?.content}
        </Content>
        <MetaInfo>
          <MetaWrapper>
            <Category>
              {paragraphData?.category.map((category, index) => (<Tag key={index} className='cpds-meta-roman-medium-book-10'>{category}</Tag>))}
            </Category>
            <AuthorInfo>
              {paragraphData?.authorInfo.map((author, index) => (<div key={index} className='cpds-body-roman-book-08'>{author}</div>))}
            </AuthorInfo>
          </MetaWrapper>
          <SponsoredBy>
            <div className='cpds-meta-roman-medium-book-10'>{paragraphData?.date}</div>
            <Cpds.SponsorTag brandText={paragraphData?.sponsoredText} brandLogo={paragraphData?.sponsoredLogo} themeTypography={'cpds-meta-roman-medium-book-10'} themeColorMode={ThemeColorMode.Light} />
          </SponsoredBy>
        </MetaInfo>
      </ContentWrpper>
    </Container>

  );
};

export default CpdsSubtitleParagraph;

